<template>
  <el-form inline :model="value" class="header-bar" size="small">
    <el-form-item label="查询年份" class="search-item">
      <el-date-picker type="year" placeholder="选择统计年份" v-model="year" value-format="yyyy" />
    </el-form-item>
    <el-form-item label="客户" class="search-item">
      <el-select v-model="value.custNo" placeholder="请选择">
        <el-option v-for=" item in custNoList" :key="item.custNo || item.id" :label="item.custName || item.deptName" :value="item.custNo || item.id"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="search-actions">
      <el-button type="primary" icon="el-icon-search" @click="handleQuery">查询</el-button>
      <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
    </el-form-item>
  </el-form>
</template>
<script>
import { getDeptSelect } from "../api";

export default {
  data () {
    return {
      custNoList: [],
      year: String(new Date().getFullYear())
    }
  },
  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },

  created () {
    this.init()
    this.syncDateRange()
  },
  methods: {
    syncDateRange () {
      if (this.year) {
        this.$set(this.value, 'startTime', `${this.year}-01-01 00:00:00`)
        this.$set(this.value, 'endTime', `${this.year}-12-31 23:59:59`)
      }
    },
    handleQuery () {
      this.syncDateRange()
      this.$emit('handleQuery')
    },
    handleReset () {
      this.$set(this.value, 'custNo', '')
      this.year = String(new Date().getFullYear())
      this.syncDateRange()
      this.$emit('handleQuery')
    },
    init () {
      getDeptSelect().then(({ data }) => {
        const list = data && data.data ? data.data : data
        this.custNoList = Array.isArray(list) ? list : []
        if (!this.value.custNo && this.custNoList.length) {
          this.$set(this.value, 'custNo', this.custNoList[0].custNo || this.custNoList[0].id)
          this.$emit('handleQuery')
        }
      })
    },
    handleDateChange () {
      // 选择完成后清空临时值，避免影响下次选择
      this.tempStart = null;
      this.tempEnd = null;
    }
  }
}
</script>

<style scoped lang="scss">
.header-bar {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 10px 24px;
  margin-bottom: 12px;
  padding: 12px 16px 10px;
  background: #f0f7ff;
  border: 1px solid #edf2f7;
  border-radius: 4px;
  box-sizing: border-box;

  .search-item {
    width: calc(25% - 18px);
    min-width: 260px;
  }

  .search-actions {
    margin-left: auto;
    text-align: right;
  }

  .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
  }

  ::v-deep .el-form-item__label {
    color: #1f2937;
    font-size: 13px;
  }

  ::v-deep .el-form-item__content,
  ::v-deep .el-date-editor,
  ::v-deep .el-select {
    width: 100%;
  }

  ::v-deep .search-actions .el-form-item__content {
    width: auto;
  }
}
</style>
